// global
import React, { useEffect, Suspense } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
// components
import Loading from 'app/components/commons/loading/Loading';
// actions
import { loginWithToken } from 'app/redux/actions/auth.action';
// storage
import { getToken } from 'app/storage/auth';
// routes config
import { getWindowModalRoutes } from './windowModalRoutes';
// stylesheets
import styles from './WindowModal.module.scss';

function WindowModal(props) {
  useEffect(() => {
    const { isAuthenticated, account } = props.auth;

    if (isAuthenticated && !account) {
      props.dispatch(loginWithToken(getToken()));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { account } = props.auth;

  const Loader = <Loading isLoading={true} message={'Aguarde...'} />;

  if (!account) {
    return Loader;
  }

  return (
    <div id='window-modal' className={styles.windowModal}>
      <Suspense fallback={Loader}>
        <Switch>
          {getWindowModalRoutes(account).map(route => {
            // Verificar se a página foi carregada diretamente pela URL
            // const isDirectAccess = !document.referrer;
            // Obter informações sobre a navegação
            // const navigationEntries = performance.getEntriesByType('navigation');

            // Referência à janela pai que a abriu.
            const windowOpener = window.opener;
            const openedByWindowOpenApi = windowOpener !== null;

            const Component = openedByWindowOpenApi ? route.component : route.notFoundComponent;

            return (
              <Route
                key={`route-${route.path}`}
                exact={route.exact}
                path={route.path}
                render={props => {
                  return <Component {...props} />;
                }}
              />
            );
          })}
        </Switch>
      </Suspense>
    </div>
  );
}

WindowModal.propTypes = {
  auth: PropTypes.object,
  dispatch: PropTypes.func
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(WindowModal);
